import { getQueryParamFromUrl, togglePassword } from './functions/utils.functions';

export class AccountEditionForm {

	// Form elements
	$form = $('#account-edition-form');
	$cancelBtn = $('#btn-cancel');

	// Fields elements
	$wantedPasswordField = $('#WantedPassword');
	$wantedPasswordConfirmationField = $('#WantedPasswordConfirmation');
	$redirectUrlField = $('#RedirectUrl');

	$togglePassword = $(".toggle-password");

	// Url params
	returnUrl: string = getQueryParamFromUrl('ReturnUrl');

	// CGU
	$closeCguBtn = $('#btn-close-cgu');
	$termsAndConditionsModal = $('#terms-and-conditions-modal');

	$profile = $('.profile');

	$imageSelect = $('.image-select');
	$imageSelector = $('.image-selector');

	$imageSelection = $('.image-selection');
	$imageSelected = $('.image-selected');
	$imageDeletion = $('.image-deletion');
	$isPictureDeleted = $('.picture-deleted');
	$profilePicture = $('.profile-picture');

	$maxSizeExceeded = $('.max-size-exceeded');
	$maxDimensionsExceeded = $('.max-dimensions-exceeded');

	constructor() {
	}

	init() {
		this.$form.submit((e) => {
			this.$profile.prop('disabled', false);
		})

		this.returnUrl = getQueryParamFromUrl('ReturnUrl');
		if (this.returnUrl) {
			this.$redirectUrlField.val(decodeURIComponent(this.returnUrl));
			this.$cancelBtn.attr('href', decodeURIComponent(this.returnUrl));
		}

		this.$closeCguBtn.on('click', (e) => {
			e.preventDefault();
			this.$termsAndConditionsModal.modal('hide');
		});

		this.$togglePassword.click(function() {togglePassword($(this))});

		this.$imageSelect.on('click', (e) => {
			this.$imageSelector.click();
		})

		this.$imageSelector.on('change', (e) => {
			const fileInput = e.target as HTMLInputElement;
			const file = fileInput.files?.[0];

			this.$maxSizeExceeded.hide();
			this.$maxDimensionsExceeded.hide();

			if (file) {
				if (file.size > 250 * 1024) {
					this.$maxSizeExceeded.show();
					return;
				}

				const reader = new FileReader();

				reader.onload = (e) => {
					const result = e.target?.result as string;

					const img = new Image();
					img.onload = () => {
						if (img.naturalWidth > 200 || img.naturalHeight > 200) {
							this.$maxDimensionsExceeded.show();
							return;
						}

						this.$profilePicture.attr('src', result);
						this.$imageSelection.hide();
						this.$imageSelected.show();
					};

					img.src = result;
				};

				reader.readAsDataURL(file);
			}
		});

		this.$imageDeletion.on('click', (e) => {
			this.$imageSelection.show();
			this.$imageSelected.hide();
			this.$imageSelector.val('');
			this.$isPictureDeleted.val('true')
		})
	}

}
